import { composeIO } from 'react-compose-io'
import { controleClassificacoesIO } from './ControleClassificacoes.IO'
import { ControleClassificacoesView } from './ControleClassificacoes.View'

export const ControleClassificacoes = composeIO(ControleClassificacoesView, controleClassificacoesIO)
